// extracted by mini-css-extract-plugin
module.exports = {"actions":"eventPage_actions__3r_Su","emphasize":"eventPage_emphasize__3MOdf","tabs":"eventPage_tabs__2Hx7E","tabPanel":"eventPage_tabPanel__1y0kt"};